import $ from "jquery";
const forgetPasswordSave = () => {
  const init = () => {
    buttonSave();
  };

  const buttonSave = () => {
    const el = {
      form: ".AccountPage form",
    };

    if ($(el.form).length === 0) return;

    const input = $(el.form).find("#password_1");
    const button = $(el.form).find("button[type='submit']");

    input.on("input blur", function () {
      if ($(this).val().length < 7) {
        setTimeout(() => {
          button.attr("disabled", true);
          button.addClass("disabled");
        }, 300);
      } else {
        button.attr("disabled", false);
        button.removeClass("disabled");
      }
    });
  };

  init();
};

try {
  forgetPasswordSave();
} catch (error) {
  // eslint-disable-next-line no-console
  console.error("forgetPasswordSave: ", error);
}
